export default "__VITE_ASSET__Cae4wbci__"